<div class="new-customer-form-container">
  <form #CustomerForm="ngForm">
    <div class="form-cards">
      <div class="form-card form-card--full">
        <div class="form-card-header">Basic Info</div>
        <div class="field-row">
          <rms-input name="CompanyName" [required]="true" label="Company Name" [(ngModel)]="Customer.CompanyName"></rms-input>
          <rms-select name="TraderID" label="Trader" [options]="Traders" labelKey="FullName" valueKey="TraderID" [(ngModel)]="Customer.TraderID"></rms-select>
        </div>
        <div class="field-row">
          <rms-input name="CreditLimit" label="Credit Limit" type="currency" [(ngModel)]="Customer.CreditLimit"></rms-input>
          <rms-input name="OciaMemberNumber" label="OCIA Member Number" [(ngModel)]="Customer.OciaMemberNumber"></rms-input>
        </div>
        <div class="field-row">
          <rms-checkbox name="NonDomestic" label="Non-Domestic" [(ngModel)]="Customer.NonDomestic"></rms-checkbox>
        </div>
      </div>

      <div class="form-card form-card--full">
        <div class="form-card-header">Contact Info</div>
        <div class="field-row">
          <rms-input name="TelephoneNumber" label="Telephone" [(ngModel)]="Customer.TelephoneNumber"></rms-input>
          <rms-input name="EmailAddress" label="Email Address" [(ngModel)]="Customer.EmailAddress"></rms-input>
        </div>
      </div>

      <div class="form-card">
        <div class="form-card-header">Shipping Address</div>
        <div class="field-row">
          <rms-input name="ShippingStreet" label="Street" [(ngModel)]="Customer.ShippingStreet"></rms-input>
          <rms-input name="ShippingCity" label="City" [(ngModel)]="Customer.ShippingCity"></rms-input>
          <rms-input name="ShippingState" label="State" [(ngModel)]="Customer.ShippingState"></rms-input>
          <rms-input name="ShippingZipCode" label="Zip" [(ngModel)]="Customer.ShippingZipCode"></rms-input>
          <rms-input name="ShippingCountry" label="Country" [(ngModel)]="Customer.ShippingCountry"></rms-input>
        </div>
      </div>

      <div class="form-card">
        <div class="form-card-header">Billing Address</div>
        <div class="field-row">
          <rms-input name="BillingStreet" label="Street" [(ngModel)]="Customer.BillingStreet"></rms-input>
          <rms-input name="BillingCity" label="City" [(ngModel)]="Customer.BillingCity"></rms-input>
          <rms-input name="BillingState" label="State" [(ngModel)]="Customer.BillingState"></rms-input>
          <rms-input name="BillingZipCode" label="Zip" [(ngModel)]="Customer.BillingZipCode"></rms-input>
          <rms-input name="BillingCountry" label="Country" [(ngModel)]="Customer.BillingCountry"></rms-input>
        </div>
      </div>

      <div class="form-card form-card--full">
        <div class="form-card-header">Payment Setup</div>
        <div class="field-row">
          <rms-select name="PaymentMethodID" label="Preferred Method" [options]="PaymentMethods" labelKey="MethodName" valueKey="PaymentMethodID" [(ngModel)]="Customer.PaymentMethodID"></rms-select>
          <rms-select name="PaymentTermId" label="Payment Terms" [options]="PaymentTerms" labelKey="PaymentTermName" valueKey="PaymentTermId" [(ngModel)]="Customer.PaymentTermId"></rms-select>
        </div>
      </div>
    </div>
  </form>
  <div class="button-container">
    <button mat-button class="btn-bg-green" [disabled]="!CustomerForm.valid" (click)="save()">Save</button>
    <button mat-button class="btn-bg-red" (click)="cancel()">Cancel</button>
  </div>
</div>
